import { createSlice } from "@reduxjs/toolkit";

export const languageModalSlice=createSlice({
    name:"languageModal",
    initialState:{
        value:{
            isOpen:false,
            selectedLanguage:null
        }
    },
    reducers:{
        getLanguageModal:(state,action)=>{
            state.value=action?.payload?.languageModal
        }
    }
})

export const {getLanguageModal}=languageModalSlice.actions
export default languageModalSlice.reducer